import IProject from "common/interfaces/IProject";
import Button from "components/Button";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hooks";
import styled from "styled-components";
import themeProps from "theme/themes";
import {
  hasApplications,
  hasMembers,
  isMember,
  isOwner,
} from "utils/projectUtils";
import { flags } from "utils/flags";
import MembersPopup from "./MembersPopup";
import ApplicantsPopup from "./ApplicantsPopup";

interface ProjectInfoProps {
  project: IProject;
}

const Wrapper = styled.div`
  margin-bottom: 45px;
`;

const Cover = styled.div`
  width: 100%;
  height: 20vh;
  max-height: 250px;
  background-color: gray;
  border-radius: 16px;
  margin-bottom: 24px;
`;
const Title = styled.h1`
  margin-bottom: 12px;
`;

const InfosWrapper = styled.div`
  display: flex;
  margin-bottom: 24px;
`;
const Info = styled.div`
  color: #fff;
  background-color: ${(props: themeProps) => props.theme.main.primary};
  border-radius: 20px;
  padding: 0 16px;
  margin-right: 12px;
  display: flex;
  height: 20px;
  align-items: center;
`;

const Description = styled.p`
  font-size: 1.2rem;
  line-height: 1.5;
`;

const Language = styled.img`
  width: 1.2rem;
  &:not(:last-child) {
    margin-right: 10px;
  }
`;

const ProjectInfo = ({ project }: ProjectInfoProps) => {
  const { t } = useTranslation("project");
  const userId = useAppSelector((state) => state.user.auth.userId);
  const [showMembers, setShowMembers] = useState(false);
  const [showApplicants, setShowApplicants] = useState(false);

  return (
    <Wrapper>
      {showMembers && (
        <MembersPopup project={project} handleClose={setShowMembers} />
      )}
      {showApplicants && (
        <ApplicantsPopup project={project} handleClose={setShowApplicants} />
      )}
      <Cover />
      <Title>{project?.title}</Title>
      <InfosWrapper>
        {project?.categories.map((category) => (
          <Info key={category}>{t(`interests:${category}`)}</Info>
        ))}
        <Info style={{ padding: "0px 16px" }}>
          {project?.languages.map((language) => {
            return <Language key={language} src={flags[language]} />;
          })}
        </Info>
        {project?.startDate && (
          <Info>
            {project.startDate}{" "}
            {project.dueDate ? `- ${project.dueDate}` : null}
          </Info>
        )}
      </InfosWrapper>
      {userId && project && isMember(project, userId) && hasMembers(project) && (
        <Button
          label={t("members")}
          styles={{
            width: "150px",
            padding: "10px 20px",
            marginBottom: "24px",
            marginRight: "16px",
          }}
          onClick={() => setShowMembers(true)}
        />
      )}
      {userId &&
        project &&
        isOwner(project, userId) &&
        hasApplications(project.roles) && (
          <Button
            label={t("applications")}
            styles={{
              width: "150px",
              padding: "10px 20px",
              marginBottom: "24px",
              marginRight: "16px",
            }}
            onClick={() => setShowApplicants(true)}
          />
        )}
      <Description>{project?.description}</Description>
    </Wrapper>
  );
};

export default ProjectInfo;
